export const navItems = [
  {
    name: 'K12 SOLUTIONS',
    subItems: [
      {
        name: 'Elementary School (PreK-5)',
        route: '/elementary',
        description: 'Engaging lessons and games',
        icon: 'fa fa-desktop',
      },
      {
        name: 'Middle School (6-8)',
        route: '/middle-school',
        description: 'Support emotional growth with stories',
        icon: 'fa fa-users',
      },
      {
        name: 'High School (9-12)',
        route: '/high-school',
        description: 'Use storytelling to build empathy',
        icon: 'fa fa-users',
      },
      {
        name: 'Professional Development',
        route: '/professionalDevelopment',
        description: 'Encourage perspective taking',
        icon: 'fa fa-handshake',
      },
      {
        name: 'Print Book Sets',
        route: 'https://shop.peekapak.com',
        description: 'K-5 levelled readers',
        icon: 'fa fa-book',
      },
    ],
  },
  {
    name: "WHO IT'S FOR",
    route: '/whoItsFor',
    subItems: [
      {
        name: 'For Administrators',
        route: '/districtLead',
        description: 'District-wide implementations',
        icon: 'fa fa-star',
      },
      {
        name: 'For Educators',
        route: '/educators',
        description: 'Plug and play lessons',
        icon: 'fa fa-graduation-cap',
      },
      { name: 'For Counselors', route: '/counselors', description: 'Tiered intervention support', icon: 'fa fa-users' },
      {
        name: 'For Corporate',
        route: '/employeeWellBeing',
        description: 'Manage employee well-being',
        icon: 'fa fa-suitcase',
      },
    ],
  },
  {
    name: 'WHY PEEKAPAK',
    subItems: [
      {
        name: 'Our Impact',
        route: '/successStories',
        description: 'Research-informed PK-12 content',
        icon: 'fa fa-search',
      },
      {
        name: 'Research',
        route: '/research',
        description: 'Design decisions based on research',
        icon: 'fa fa-search',
      },
      {
        name: 'Success Stories',
        route: '/successStories',
        description: 'Our impact on students and schools',
        icon: 'fa fa-book',
      },
      { name: 'Our Team', route: '/about', description: 'The humans behind Peekapak', icon: 'fa fa-users' },
      { name: 'Press', route: '/press', description: 'See Peekapak in action', icon: 'fa fa-camera' },
    ],
  },
  {
    name: 'RESOURCES',
    subItems: [
      {
        name: 'Funding',
        route: '/funding',
        description: 'Alignment with state funding',
        icon: 'fa fa-credit-card-alt',
      },
      {
        name: 'Technical Specs',
        route: '/techSpecs',
        description: 'Requirements to run Peekapak',
        icon: 'fa fa-lightbulb',
      },
      { name: 'Webinars', route: '/webinars', description: 'Free PD Webinars', icon: 'fa fa-desktop' },
      { name: 'Blog', route: 'https://blog.peekapak.com', description: 'Stay up to date', icon: 'fa fa-rss' },
      {
        name: 'FAQs',
        route: 'https://help.peekapak.com',
        description: 'To support you',
        icon: 'fa fa-question-circle',
      },
    ],
  },
  { name: 'LOGIN', route: '/login', description: 'Access the platform', icon: '' },
];
